import React from "react";
import styles from "./BookYourStay.module.css";

interface BookStayProps {
  isVisible: boolean;
}

const BookStay: React.FC<BookStayProps> = ({ isVisible }) => {
  const handleBookStayClick = () => {
    window.open("https://booking.staylist.app/Hideaway", "_blank");
  };

  return (
    <div className={styles.bookYourStayBox}>
      <h1
        className={`${styles.bookYourStay} ${isVisible ? styles.bookYourStayVisible : ""}`}
        onClick={handleBookStayClick}
      >
        Book Now
      </h1>
    </div>
  );
};

export default BookStay;
